import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '@/layout'

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  }
]

export const asyncRoutes = [
  {
    path: '/',
    component: Layout,
    children: [{
      path: 'salesdata',
      name: 'salesdata',
      component: () => import('@/views/user/SalesData/index'),
      meta: { title: '业绩数据', icon: 'el-icon-trophy', roles: ['seller'] }
    }]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/worktop.js',
    children: [{
      path: 'worktop',
      name: '工作台',
      component: () => import('@/views/worktop/index.vue'),
      meta: { title: '运营工作台', icon: 'el-icon-monitor', roles: ['dispatcher'] }
    }]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/sellerworktop',
    children: [{
      path: 'sellerworktop',
      name: 'sellerworktop',
      component: () => import('@/views/worktop/SellerWorktop/index.vue'),
      meta: { title: '业务工作台', icon: 'el-icon-office-building', roles: ['seller'] }
    }]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/salseleaderworktop',
    children: [{
      path: 'salseleaderworktop',
      name: 'salseleaderworktop',
      component: () => import('@/views/worktop/SalseLeaderWorktop/index.vue'),
      meta: { title: '业务组长工作台', icon: 'el-icon-s-flag', roles: ['sellerleader'] }
    }]
  },
  {
    path: '/user',
    name: 'user',
    component: Layout,
    children: [
      {
        name: '我的消息',
        path: '/mymessage',
        component: () => import('@/views/user/message'),
        hidden: true,
        meta: { title: '我的消息', icon: 'el-icon-message', roles: ['admin', 'seller', 'dispatcher'] }
      }
    ]
  },
  {
    path: '/search',
    component: Layout,
    redirect: 'noRedirect',
    name: 'orders',
    meta: { title: '信息检索', icon: 'el-icon-search', roles: ['seller', 'dispatcher', 'admin', 'writerrecruiter', 'SocialMediaOperator'] },
    children: [
      {
        path: '/search/search',
        name: 'search',
        component: () => import('@/views/search/search/index.vue'),
        meta: { title: '订单搜索', icon: 'el-icon-document-copy', roles: ['seller', 'admin', 'SocialMediaOperator'] }
      },
      {
        path: '/search/dispatchersearch',
        name: 'dispatchersearch',
        component: () => import('@/views/search/dispatchsearch/index.vue'),
        meta: { title: '派发搜索', icon: 'el-icon-s-promotion', roles: ['dispatcher', 'writerrecruiter'] }
      },
      {
        path: '/search/coursedetail',
        name: 'coursedetail',
        component: () => import('@/views/course/index.vue'),
        meta: { title: '新建课程详情', icon: 'el-icon-notebook-2', roles: ['dispatcher', 'writerrecruiter'] },
        children: [
          {
            path: '/search/searchcoursedetail',
            name: 'searchcoursedetail',
            component: () => import('@/views/course/searchCourseDetail/index.vue'),
            meta: { title: '搜索课程详情', icon: 'el-icon-search', roles: ['dispatcher', 'writerrecruiter'] }
          },
          {
            path: '/search/newcoursedetail',
            name: 'newcoursedetail',
            component: () => import('@/views/course/newCourseData/index.vue'),
            meta: { title: '新建课程详情', icon: 'el-icon-circle-plus-outline', roles: ['dispatcher', 'writerrecruiter'] }
          }
        ]
      }
    ]
  },
  {
    path: '/orders',
    component: Layout,
    redirect: 'noRedirect',
    name: 'orders',
    meta: { title: '订单管理', icon: 'el-icon-s-order', roles: ['seller', 'admin'] },
    children: [
      {
        path: 'PreOrderList',
        name: 'PreOrderList',
        component: () => import('@/views/order/preorder/preorderlist/index.vue'),
        meta: { title: '询单列表', icon: 'el-icon-chat-line-round', roles: ['seller', 'admin'] }
      },
      {
        path: 'newOrder',
        name: 'newOrder',
        component: () => import('@/views/order/newneworder/index.vue'),
        meta: { title: '创建新订单', icon: 'el-icon-circle-plus-outline', roles: ['seller', 'admin'] }
      },
      {
        path: 'table',
        name: 'Table',
        component: () => import('@/views/salsetable/index.vue'),
        meta: { title: '我的订单', icon: 'el-icon-tickets', roles: ['seller', 'admin'] }
      }
    ]
  },
  {
    path: '/dispatcher',
    component: Layout,
    redirect: 'noRedirect',
    name: 'orders',
    meta: { title: '派单', icon: 'el-icon-position', roles: ['dispatcher', 'admin'] },
    children: [
      {
        path: '/dispatcherinfo',
        name: 'dispatcherinfo',
        component: () => import('@/views/dashboard/dispatcher/index'),
        meta: { title: '派单面板', icon: 'el-icon-data-board', roles: ['admin', 'dispatcher'] }
      },
      {
        path: '/dispatcher',
        name: 'dispatcher',
        component: () => import('@/views/dispatcher/index'),
        meta: { title: '派单', icon: 'el-icon-position', roles: ['admin', 'dispatcher'] }
      },
      {
        path: '/mywritersettlement',
        name: 'mywritersettlement',
        component: () => import('@/views/dispatcher/mySettlementList/index.vue'),
        meta: { title: '我的结款列表', icon: 'el-icon-coin', roles: ['admin', 'dispatcher'] }
      },
      {
        path: '/dispatcher/batchcomplete',
        name: 'batchcomplete',
        component: () => import('@/views/dispatcher/batchComplete/index.vue'),
        meta: { title: '写手批量结算', icon: 'el-icon-files', roles: ['admin', 'dispatcher'] }
      },
      {
        path: '/dispatcherrefunds',
        name: 'dispatcherrefunds',
        component: () => import('@/views/dispatcher/components/DispatchRefundsList/index'),
        meta: { title: '派单退款审核', icon: 'el-icon-refresh-left', roles: ['admin', 'dispatcher'] }
      }
    ]
  },
  {
    path: '/clients',
    component: Layout,
    redirect: 'noRedirect',
    name: 'clients',
    meta: { title: '客户管理', icon: 'el-icon-user', roles: ['admin', 'seller', 'uploadpotentialclients'] },
    children: [
      {
        path: '/myclients',
        name: 'myclients',
        component: () => import('@/views/client/myclients/index.vue'),
        meta: { title: '我的客户', icon: 'el-icon-s-custom', roles: ['admin', 'seller'] }
      },
      {
        path: '/myreturnvisitlist',
        name: 'myreturnvisitlist',
        component: () => import('@/views/client/returnvisitlist/index'),
        meta: { title: '我的建联记录', icon: 'el-icon-chat-dot-round', roles: ['admin', 'seller'] }
      },
      {
        path: 'potentialclient',
        name: 'potentialclient',
        redirect: 'noRedirect',
        component: () => import('@/views/compeny/index'),
        meta: { title: '潜在客户管理', icon: 'el-icon-connection', roles: ['admin', 'seller'] },
        children: [
          {
            path: '/adoptclients',
            name: 'adoptclients',
            component: () => import('@/views/client/adoptclientlist/index'),
            meta: { title: '认领客户列表', icon: 'el-icon-s-custom', roles: ['admin', 'seller'] }
          },
          {
            path: '/potentialclientslist',
            name: 'potentialclientslist',
            component: () => import('@/views/client/preclientlist/index'),
            meta: { title: '潜在客户列表', icon: 'el-icon-user', roles: ['admin', 'sellerleader', 'uploadpotentialclients'] }
          },
          {
            path: '/recpotentialclientslist',
            name: 'recpotentialclientslist',
            component: () => import('@/views/client/recpclientlist/index'),
            meta: { title: '推荐潜在客户列表', icon: 'el-icon-star-on', roles: ['admin', 'sellerleader'] }
          },
          {
            path: '/uploadpotentialclients',
            name: 'uploadpotentialclients',
            component: () => import('@/views/client/uploadpreclient/index'),
            meta: { title: '潜在客户上传', icon: 'el-icon-upload2', roles: ['admin', 'uploadpotentialclients'] }
          }
        ]
      }
    ]
  },
  {
    path: '/writers',
    component: Layout,
    redirect: 'noRedirect',
    name: 'writers',
    meta: { title: '写手管理', icon: 'el-icon-edit', roles: ['admin', 'writerrecruiter', 'dispatcher'] },
    children: [
      {
        path: '/writerslist',
        name: 'writerslist',
        component: () => import('@/views/writer/writerslist/index.vue'),
        meta: { title: '写手列表', icon: 'el-icon-user', roles: ['admin', 'writerrecruiter', 'dispatcher'] }
      },
      {
        path: '/writerrank',
        name: 'writerrank',
        component: () => import('@/views/writer/writerrank/index'),
        meta: { title: '写手排行', icon: 'el-icon-medal', roles: ['admin', 'writerrecruiter', 'dispatcher'] }
      }
    ]
  },
  {
    path: '/groupmanegement',
    component: Layout,
    redirect: 'noRedirect',
    meta: { title: '小组管理', icon: 'el-icon-s-cooperation', roles: ['superadmin', 'admin', 'sellerleader', 'CompanyDataViewer'] },
    children: [
      {
        path: 'groupinfo',
        name: 'groupinfo',
        component: () => import('@/views/group/groupinfo/index'),
        meta: { title: '小组数据', icon: 'el-icon-pie-chart', roles: ['sellerleader', 'CompanyDataViewer'] }
      },
      {
        path: 'groupmanegement',
        name: 'groupmanegement',
        component: () => import('@/views/group/grouporderstable/index.vue'),
        meta: { title: '小组订单', icon: 'el-icon-tickets', roles: ['sellerleader'] }
      },
      {
        path: 'grouprefunds',
        name: 'grouprefunds',
        component: () => import('@/views/group/grouprefunds/index.vue'),
        meta: { title: '小组退款审核', icon: 'el-icon-refresh-left', roles: ['superadmin', 'admin', 'sellerleader'] }
      },
      {
        path: '/grouppreorderlist',
        name: 'grouppreorderlist',
        component: () => import('@/views/group/grouppreorder/index.vue'),
        meta: { title: '小组询单列表', icon: 'el-icon-chat-line-round' }, roles: ['sellerleader']
      },
      {
        path: 'groupmembers',
        name: 'groupmembers',
        component: () => import('@/views/group/groupmembers/index'),
        meta: { title: '小组成员', icon: 'el-icon-s-custom', roles: ['sellerleader'] }
      },
      {
        path: 'groupsellerwechat',
        name: 'groupsellerwechat',
        component: () => import('@/views/group/groupsellerwechat/index.vue'),
        meta: {
          title: '小组业务微信',
          icon: 'el-icon-chat-dot-round',
          roles: ['sellerleader']
        }
      },
      {
        path: 'groupclients',
        name: 'groupclients',
        component: () => import('@/views/group/groupclients/index'),
        meta: { title: '小组客户', icon: 'el-icon-user', roles: ['sellerleader'] }
      },
      {
        path: 'groupmemberdailyreport',
        name: 'groupmemberdailyreport',
        component: () => import('@/views/group/memberdailyreport/index'),
        meta: { title: '小组每日数据', icon: 'el-icon-date', roles: ['sellerleader'] }
      }
    ]
  },
  {
    path: '/companymanegement',
    component: Layout,
    redirect: 'noRedirect',
    meta: { title: '公司管理', icon: 'el-icon-office-building', roles: ['admin', 'CompanyDataViewer', 'SalesDirector'] },
    children: [
      {
        path: 'companydailyreport',
        name: 'companydailyreport',
        component: () => import('@/views/compeny/companydailydata/index.vue'),
        meta: { title: '公司每日数据', icon: 'el-icon-date', roles: ['admin', 'CompanyDataViewer'] }
      },
      {
        path: 'ordersmanegement',
        name: 'ordersmanegement',
        redirect: 'noRedirect',
        component: () => import('@/views/compeny/index'),
        meta: { title: '订单总管理', icon: 'el-icon-s-order', roles: ['admin', 'SalesDirector'] },
        children: [
          {
            path: 'compenyorders',
            name: 'compenyorders',
            component: () => import('@/views/compeny/compenyorders/index.vue'),
            meta: { title: '公司订单列表', icon: 'el-icon-tickets', roles: ['admin', 'SalesDirector'] }
          },
          {
            path: 'companydispatchlist',
            name: 'companydispatchlist',
            component: () => import('@/views/compeny/companydispatchlist/index.vue'),
            meta: { title: '公司派单列表', icon: 'el-icon-position', roles: ['DispatchDirector'] }
          }
        ]
      },
      {
        path: 'companysellerwechat',
        name: 'companysellerwechat',
        redirect: 'noRedirect',
        component: () => import('@/views/compeny/index'),
        meta: { title: '客户管理', icon: 'el-icon-user', roles: ['admin'] },
        children: [
          {
            path: 'companyclients',
            name: 'companyclients',
            component: () => import('@/views/compeny/companyclients/index.vue'),
            meta: { title: '公司客户列表', icon: 'el-icon-user', roles: ['admin'] }
          },
          {
            path: 'companysellerwechat',
            name: 'companysellerwechat',
            component: () => import('@/views/compeny/sellerwechat/index.vue'),
            meta: { title: '公司业务微信', icon: 'el-icon-mobile-phone', roles: ['admin'] }
          }
          // {
          //   path: 'companysellerwechatdetail',
          //   name: 'companysellerwechatdetail',
          //   component: () => import('@/views/compeny/sellerwechatdetail/index.vue'),
          //   meta: { title: '业务微信详情', icon: 'el-icon-s-custom', roles: ['admin'] }
          // }
        ]
      },
      {
        path: 'expense',
        name: 'expense',
        redirect: 'noRedirect',
        component: () => import('@/views/compeny/index'),
        meta: { title: '财务管理', icon: 'el-icon-bank-card', roles: ['admin'] },
        children: [
          {
            path: 'payment',
            name: 'payment',
            component: () => import('@/views/compeny/payments/index'),
            meta: { title: '付款审核', icon: 'el-icon-finished', roles: ['admin'] }
          }
        ]
      },
      {
        path: 'account',
        name: 'account',
        component: () => import('@/views/compeny/account/index.vue'),
        meta: { title: '账号管理', icon: 'el-icon-key', roles: ['superadmin', 'admin'] }
      },
      {
        path: '/companysalesdataaboard',
        name: 'companysalesdataaboard',
        component: () => import('@/views/databoard/companysalesdata/index.vue'),
        meta: { title: '公司业务数据', icon: 'el-icon-s-marketing' }, roles: ['seller']
      },
      {
        path: 'companygroups',
        name: 'companygroups',
        component: () => import('@/views/compeny/group/index.vue'),
        meta: { title: '公司小组管理', icon: 'el-icon-s-cooperation', roles: ['admin'] }
      },
      {
        path: 'paymentaccount',
        name: 'paymentaccount',
        component: () => import('@/views/compeny/paymentaccount/index'),
        meta: { title: '收款账户管理', icon: 'el-icon-wallet', roles: ['admin'] }
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: 'noRedirect',
    meta: { title: '系统管理', icon: 'el-icon-setting', roles: ['superadmin'] },
    children: [
      {
        path: 'systemordersmanegement',
        name: 'systemordersmanegement',
        redirect: 'noRedirect',
        component: () => import('@/views/compeny/index'),
        meta: { title: '订单总管理', icon: 'el-icon-s-order', roles: ['superadmin'] },
        children: [
          {
            path: 'systemorders',
            name: 'systemorders',
            component: () => import('@/views/system/systemorders/index.vue'),
            meta: { title: '系统订单列表', icon: 'el-icon-tickets', roles: ['superadmin'] }
          }
        ]
      }
    ]
  },
  {
    path: '/socialmedia',
    component: Layout,
    redirect: 'noRedirect',
    meta: { title: '社交媒体', icon: 'el-icon-share', roles: ['SocialMediaOperator'] },
    children: [
      {
        path: 'socialmedia',
        name: 'socialmedia',
        component: () => import('@/views/socialmedia/index'),
        meta: { title: '社交媒体', icon: 'el-icon-share', roles: ['SocialMediaOperator'] }
      },
      {
        path: 'operator',
        name: 'operator',
        component: () => import('@/views/dashboard/operator/index.vue'),
        meta: { title: '运营数据看板', icon: 'el-icon-data-line', roles: ['SocialMediaOperator'] }
      }
    ]
  },
  {
    path: '/MyAccount',
    component: Layout,
    redirect: 'noRedirect',
    name: '我的',
    meta: { title: '我的', icon: 'el-icon-user-solid' },
    children: [
      {
        path: '/invoice',
        name: 'invoice',
        component: () => import('@/views/myaccount/Invoice/index'),
        meta: { title: '收退款', icon: 'el-icon-money', roles: ['seller'] }
      },
      {
        path: '/salesdataaboard',
        name: 'salesdataaboard',
        component: () => import('@/views/databoard/companysalesdata/index.vue'),
        meta: { title: '业务数据', icon: 'el-icon-s-marketing' }, roles: ['seller']
      },
      {
        path: '/approvals',
        name: 'approvals',
        component: () => import('@/views/myaccount/approvals/index'),
        meta: { title: '审核', icon: 'el-icon-finished' }
      }
    ]
  },
  {
    path: '/writer-finance',
    component: Layout,
    redirect: 'noRedirect',
    meta: { title: '写手财务', icon: 'money', roles: ['superadmin'] },
    children: [
      {
        path: 'settlement',
        name: 'WriterSettlement',
        component: () => import('@/views/settlement/index'),
        meta: { title: '写手结款', icon: 'money', roles: ['superadmin'] }
      },
      {
        path: 'payment-batch',
        name: 'WriterPaymentBatch',
        component: () => import('@/views/paymentBatch/index.vue'),
        meta: { title: '写手打款', icon: 'money', roles: ['superadmin'] }
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: 'noRedirect',
    name: '业务日报 ',
    meta: { title: '业务日报', icon: 'el-icon-notebook-2', roles: ['seller'] },
    children: [
      {
        path: '/sellerDailyReport',
        name: 'SellerDailyReport',
        component: () => import('@/views/myaccount/dailyreport/index'),
        meta: { title: '业务日报', icon: 'el-icon-notebook-2' }, roles: ['seller']
      }
    ]
  },
  {
    path: '/dashboard',
    component: Layout,
    name: 'dashboard',
    meta: { title: '数据看板', icon: 'el-icon-s-data', roles: ['admin', 'sellerleader', 'dispatcher', 'seller'] },
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/admin/index.vue'),
        meta: { title: '数据看板', icon: 'el-icon-s-data', roles: ['admin', 'sellerleader', 'dispatcher', 'seller'] }
      }
    ]
  },
  {
    path: '/internalDoc',
    component: Layout,
    children: [
      {
        path: '',
        name: 'publicpage',
        component: () => import('@/views/internalDocs/index.vue'),
        meta: { title: '系统使用文档', icon: 'el-icon-reading' }
      }
    ]
  },
  { path: '*', redirect: '/404' }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
